<template>
  <v-card elevation="0" outlined rounded="xl" min-width="100%">
    <v-card-title>
      <div
        class="mx-auto text-caption text-uppercase text--secondary"
      >
        Условия подачи
      </div>
    </v-card-title>
    <div
      class="text-center d-flex align-center justify-center"
      style="min-height: 100%"
      v-if="!user.registration_address && !fluorography"
    >
      <v-progress-circular class="pa-0 ma-0" size="100" color="teal" width="4" indeterminate/>
    </div>
    <v-list three-line v-else>
      <v-list-item :class="regAdr.color_text">
        <v-list-item-icon>
          <v-tooltip class="rounded-xl" max-width="50%" bottom :color="regAdr.color">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="regAdr.color"
                v-text="regAdr.icon"
                v-bind="attrs"
                v-on="on"
              ></v-icon>
            </template>
            <span v-text="regAdr.text_allowance"></span>
          </v-tooltip>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>АДРЕС РЕГИСТРАЦИИ</v-list-item-title>
          <v-list-item-subtitle>
            {{ user.registration_address }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :class="allow_fluorography.color_text">
        <v-list-item-icon>
          <v-tooltip class="rounded-xl" max-width="50%" bottom :color="allow_fluorography.color">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="allow_fluorography.color"
                v-text="allow_fluorography.icon"
                v-bind="attrs"
                v-on="on"
              ></v-icon>
            </template>
            <span v-text="allow_fluorography.text_allowance"></span>
          </v-tooltip>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>ФЛЮОРОГРАФИЯ</v-list-item-title>
          <v-list-item-subtitle v-if="allow_fluorography.text">
            {{ allow_fluorography.text }}
          </v-list-item-subtitle>
          <v-list-item-subtitle v-else>
            <v-btn
              href="https://cabinet.amursu.ru/fluorography/new"
              outlined
              small
              color="teal"
            >
              Добавить флюорографию
            </v-btn>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

<!--    <div v-if="!fluorography">-->
<!--      <div class="mt-4 mx-4">-->
<!--        <v-alert-->
<!--          class="text-left"-->
<!--          border="left"-->
<!--          color="teal"-->
<!--          text-->
<!--          type="info"-->
<!--        >-->
<!--          На данный момент у Вас нет актуальной информации о прохождении флюорографии.-->
<!--          Необходимо добавить её в разделе "Флюорография", наличие данного документа является-->
<!--          обязательным для подачи заявления на место в общежитии.-->
<!--          <div class="text-right mt-2">-->
<!--          </div>-->
<!--        </v-alert>-->
<!--      </div>-->
<!--    </div>-->
  </v-card>
</template>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

    export default {
        name: "CardStatusesAllowance",
        data: () => ({}),
        components: {},
        mounted: function () {
        },
        computed: {
            ...mapState({
                user: state => state.mainHostel.user,
                fluorography: state => state.mainHostel.fluorography,
            }),
            ...mapGetters({}),
            regAdr() {
                const user = this.user?.registration_address
                let all = user?.match(/[^,]*/mg)
                let index = user?.match(/[^,]*/mg)[0]
                let obl = user?.match(/[^,]*/mg)[2]
                let city = user?.match(/[^,]*/mg)[4]
                let street = user?.match(/[^,]*/mg)[6]
                let home = user?.match(/[^,]*/mg)[8]
                let apartment = user?.match(/[^,]*/mg)[10]
                // if (this.privilege?.name !== null) return false

                let allowance_reg_adr
                if (Number(index) >= 675000 && Number(index) <= 675029) {
                    allowance_reg_adr = 'Вы не можете подавать заявления на общежитие так, как ваш регистрационный адрес: ' +
                        'индекс ' + index + ', ' + obl + ' область ' + ', ' + city + ', улица' + street + ', ' + home + ', ' + apartment
                } else allowance_reg_adr = 'В допуске'

                return {
                    color: allowance_reg_adr !== 'В допуске' ? 'red' : 'green',
                    color_text: allowance_reg_adr !== 'В допуске' ? 'red--text' : 'green--text',
                    icon: allowance_reg_adr !== 'В допуске' ? 'fa-times-circle' : 'fa-check-circle',
                    text_allowance: allowance_reg_adr
                }
            },
            allow_fluorography(){
                let fluorography = Object.assign({}, this.fluorography)
                let allowance_fluorography
                let pathology
                let full_text

                if (!fluorography) {
                    allowance_fluorography =
                        'На данный момент у Вас нет актуальной информации о прохождении флюорографии. ' +
                        'Необходимо добавить её в разделе "Флюорография", наличие данного документа является ' +
                        'обязательным для подачи заявления на место в общежитии.'
                } else {
                    allowance_fluorography = 'В допуске'
                    pathology = fluorography.no_pathology === true ? 'Без патологий' : 'С патологиями'
                    full_text = fluorography.name_hospital + ', ' + fluorography.date + ', ' + pathology
                }
                return {
                    color: allowance_fluorography !== 'В допуске' ? 'red' : 'green',
                    color_text: allowance_fluorography !== 'В допуске' ? 'red--text' : 'green--text',
                    icon: allowance_fluorography !== 'В допуске' ? 'fa-times-circle' : 'fa-check-circle',
                    text: full_text,
                    text_allowance: allowance_fluorography
                }
            }
        },
        watch: {},
        methods: {
            ...mapMutations({}),
            ...mapActions({}),
        },
    }
</script>

<style scoped>

</style>